import * as React from 'react';

import Box from '@mui/material/Box';

export default function About(){
    return (
        <Box className='wrapper about'>
            <h2 className='section-title'>About the Journey</h2>
            <p className='desc'>
            The Finance Management Associate (FMA) Program is a 2-year accelerated pathway for aspiring talents seeking to excel in the accounting and finance profession. Through four 6-month rotations within our Finance team, you will be immersed in Sea’s various businesses (Garena, Shopee, and SeaMoney) and experience firsthand the pivotal role Finance plays in each of these businesses. Applications are open from 15 Aug 2024 to 15 Oct 2024. 
            </p>
        </Box>
    );
}
